import React from "react";
import "./Navbar.css";

const Navbar = ({ children }) => {
  return (
    <nav>
      <div className="navbar">{children}</div>
    </nav>
  );
};

export default Navbar;
